import { render, staticRenderFns } from "./UserLinkCompanyDialog.vue?vue&type=template&id=adc1f50a&scoped=true"
import script from "./UserLinkCompanyDialog.vue?vue&type=script&lang=js"
export * from "./UserLinkCompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc1f50a",
  null
  
)

export default component.exports